<template>
    <div class="ad">
        <img src="../../assets/images/ad.png" alt="">
    </div>
</template>

<script>
import Image1 from "../image";

export default{
    name: 'Ad',
    props:{
        adImg: String
    }
}
</script>

<style lang="less" scoped>
    .ad{
        padding: 0 0.3rem;
        margin-top: 0.4rem;
        img{
            width: 100%;
            border-radius: 0.2rem;
        }
    }          
</style>   